"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PHONE_NUMBER_UK_MOBILE = exports.PHONE_NUMBER_ALTERNATIVE = exports.PHONE_NUMBER = void 0;
var _Input = _interopRequireDefault(require("../../elements/input/Input"));
var _formatPhoneNumber = _interopRequireDefault(require("../normalizers/formatPhoneNumber"));
var _formatPhoneNumberUkMobile = _interopRequireDefault(require("../normalizers/formatPhoneNumberUkMobile"));
var _regex = require("../regex");
var _phoneNumberUK = _interopRequireDefault(require("../validation/phoneNumberUK"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var formValidationPhoneNumberInvalid = 'We don’t recognise this number, if this is an international number enter your country’s dialling code (e.g. +33)';
var formValidationPhoneNumberRequired = 'Please enter a phone number';
var formValidationPhoneNumberMaxLength = "The number you've entered is too long";
var PHONE_NUMBER = exports.PHONE_NUMBER = {
  component: _Input["default"],
  name: 'phoneNumber',
  label: 'Phone number',
  id: 'phoneNumber',
  type: 'tel',
  placeholder: 'e.g. 07711223344',
  autoComplete: 'off',
  className: 'fieldLargeInputMedium',
  required: true,
  maxLength: 15,
  regex: _regex.phoneNumberRegex,
  validationMessageKeys: {
    required: formValidationPhoneNumberRequired,
    maxLength: formValidationPhoneNumberMaxLength,
    maxLengthInt: formValidationPhoneNumberMaxLength,
    regex: formValidationPhoneNumberInvalid,
    invalid: formValidationPhoneNumberInvalid
  },
  validationFnc: _phoneNumberUK["default"],
  normalize: _formatPhoneNumber["default"]
};
var PHONE_NUMBER_UK_MOBILE = exports.PHONE_NUMBER_UK_MOBILE = _objectSpread(_objectSpread({}, PHONE_NUMBER), {}, {
  label: 'Mobile number',
  placeholder: 'e.g. 07711223344',
  autoComplete: 'on',
  className: 'fieldLargeInputMedium',
  required: true,
  maxLength: 15,
  regex: _regex.phoneNumberUkMobileRegex,
  validationMessageKeys: {
    required: formValidationPhoneNumberRequired,
    maxLength: formValidationPhoneNumberMaxLength,
    regex: 'Please enter a UK mobile number, not a landline or international number'
  },
  validationFnc: undefined,
  normalize: _formatPhoneNumberUkMobile["default"]
});
var PHONE_NUMBER_ALTERNATIVE = exports.PHONE_NUMBER_ALTERNATIVE = _objectSpread(_objectSpread({}, PHONE_NUMBER), {}, {
  name: 'phoneNumberAlternative',
  label: 'Alternative number',
  id: 'phoneNumberAlternative',
  required: false
});